/* Entwurf B „Werkstatt“: Variantensync, Galerie-Zähler, mobile Kaufleiste, Overlay-Zonen, Zubehör-Schnellkauf. */
(function () {
  const BAR_ABSTAND = 80; // px, um die Trusted-Shops-Siegel und Chat-Blase über die 72-px-Leiste gehoben werden

  function initProduct(root) {
    const sectionId = root.dataset.section;
    // Splittest 21.10.2026: ?view= nur in der Vorschau anhängen. In den normalen Produktvorlagen (Schalter „Entwurf B“) bleibt die URL wie bei Dawn.
    const view = new URLSearchParams(window.location.search).get('view') || '';

    // Vorschau: ?view= bei Variantenwechsel behalten (Dawn hängt sonst nur section_id/variant an).
    if (view && typeof root.buildRequestUrlWithParams === 'function') {
      const orig = root.buildRequestUrlWithParams.bind(root);
      root.buildRequestUrlWithParams = (url, ov, full) => {
        const u = orig(url, ov, full);
        return u + (u.includes('?') ? '&' : '?') + 'view=' + encodeURIComponent(view);
      };
      root.updateURL = (url, variantId) => {
        const q = new URLSearchParams({ view });
        if (variantId) q.set('variant', variantId);
        window.history.replaceState({}, '', url + '?' + q.toString());
      };
    }

    const bar = root.querySelector('[data-urb-b-bar]');
    const barBtn = root.querySelector('[data-urb-b-bar-btn]');
    const mainBtn = () => root.querySelector('#ProductSubmitButton-' + sectionId);

    // Kaufleisten-Button = echter Kaufbutton (eine Logik, ein Formular).
    barBtn?.addEventListener('click', () => mainBtn()?.click());
    const spiegeln = () => {
      const b = mainBtn();
      if (!b || !barBtn) return;
      const aus = b.hasAttribute('disabled');
      barBtn.disabled = aus;
      barBtn.textContent = aus ? (b.textContent.trim() || 'Ausverkauft') : 'In den Warenkorb';
    };
    const btn = mainBtn();
    if (btn) new MutationObserver(spiegeln).observe(btn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });

    // Variantenwechsel: alle data-urb-b-sync-Elemente aus der frisch gerenderten Section übernehmen.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || data.sectionId !== sectionId) return;
        root.querySelectorAll('[data-urb-b-sync]').forEach((el) => {
          const src = data.html.getElementById(el.id);
          if (src) el.innerHTML = src.innerHTML;
        });
        pdfAktualisieren(data.variant);
        spiegeln();
        stickyTop();
      });
    }

    // Galerie-Zähler (mobil)
    const liste = root.querySelector('[data-urb-b-galerie-liste]');
    const ist = root.querySelector('[data-urb-b-zaehler-ist]');
    if (liste && ist) {
      let raf = 0;
      liste.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const w = liste.firstElementChild ? liste.firstElementChild.getBoundingClientRect().width : liste.clientWidth;
          ist.textContent = String(Math.min(liste.children.length, Math.round(liste.scrollLeft / Math.max(1, w)) + 1));
        });
      }, { passive: true });
    }

    // Kaufleiste: erscheint, sobald der Kaufbutton nach oben aus dem Bild gescrollt ist.
    const buy = root.querySelector('[data-urb-b-buy]');
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const zeigen = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', zeigen);
        bar.setAttribute('aria-hidden', zeigen ? 'false' : 'true');
        overlaysHeben(zeigen);
        if (zeigen) setTimeout(() => overlaysHeben(bar.classList.contains('is-visible')), 1200);
      }).observe(buy);
    }

    // Desktop: rechte Spalte klebt; ist sie höher als der Bildschirm, klebt sie an ihrer Unterkante.
    const col = root.querySelector('[data-urb-b-sticky-col]');
    function stickyTop() {
      if (!col) return;
      if (window.innerWidth < 990) { col.style.top = ''; return; }
      col.style.top = Math.min(24, window.innerHeight - col.offsetHeight - 24) + 'px';
    }
    stickyTop();
    window.addEventListener('resize', stickyTop);
    window.addEventListener('load', stickyTop);
  }

  // Fremd-Overlays (Trusted-Shops-Siegel unten links, Chat-Blase unten rechts) über die Leiste heben.
  function overlaysHeben(an) {
    if (window.innerWidth >= 990) return;
    const grenze = window.innerHeight - 76;
    const kandidaten = [];
    const sammeln = (el, tiefe) => {
      if (!el || tiefe > 3) return;
      for (const k of el.children) {
        if (k.closest('.urb-b, #CybotCookiebotDialog, #CybotCookiebot')) continue;
        if (['SCRIPT', 'STYLE', 'LINK', 'MAIN', 'HEADER', 'FOOTER', 'SECTION'].includes(k.tagName)) continue;
        const cs = getComputedStyle(k);
        if (cs.position === 'fixed' && cs.display !== 'none') {
          const r = k.getBoundingClientRect();
          if (r.height > 0 && r.height < 220 && r.width < 320 && (r.bottom > grenze || k.hasAttribute('data-urb-b-gehoben'))) kandidaten.push(k);
          continue;
        }
        sammeln(k, tiefe + 1);
      }
    };
    sammeln(document.body, 0);
    kandidaten.forEach((k) => {
      k.setAttribute('data-urb-b-gehoben', '');
      k.style.translate = an ? `0 -${BAR_ABSTAND}px` : '';
    });
  }

  function pdfAktualisieren(variant) {
    const a = document.querySelector('[data-urb-b-pdf]');
    const map = document.querySelector('[data-urb-b-pdf-map]');
    if (!a || !map || !variant) return;
    try {
      const url = JSON.parse(map.textContent)[String(variant.id)];
      if (url) { a.href = url; a.hidden = false; }
    } catch (e) { /* ignorieren */ }
  }

  // Zubehör: Schnellkauf mit Dawn-Warenkorb-Benachrichtigung
  document.addEventListener('click', async (ev) => {
    const b = ev.target.closest('[data-urb-b-add]');
    if (!b) return;
    ev.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { id: Number(b.dataset.urbBAdd), quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
      cart.setActiveElement?.(b);
    }
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json();
      if (!r.ok || j.status) throw new Error(j.description || j.message || 'Fehler');
      b.classList.add('is-drin');
      const t = b.querySelector('[data-urb-b-add-text]');
      if (t) t.textContent = 'Im Warenkorb';
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'urb-entwurf-b', productVariantId: body.id, cartData: j });
      if (cart && j.sections) cart.renderContents(j);
    } catch (e) {
      const t = b.querySelector('[data-urb-b-add-text]');
      if (t) t.textContent = 'Nicht möglich';
      console.error(e);
    } finally {
      b.disabled = false;
    }
  });

  const start = () => document.querySelectorAll('product-info.urb-b').forEach(initProduct);
  if (customElements.get('product-info')) start();
  else customElements.whenDefined('product-info').then(start);
})();
